import Vue from 'vue'
import VueFormulate from './formulate/formulate'

import VTooltip from 'v-tooltip'

import VueMeta from 'vue-meta'

import VueMask from 'v-mask'
Vue.use(VueMask)

import VehicleCoverSlider from '@/components/initio/formulate/VehicleCoverSlider.vue'
Vue.component('VehicleCoverSlider', VehicleCoverSlider)

import VehicleCommercial from '@/components/initio/formulate/VehicleCommercial.vue'
Vue.component('VehicleCommercial', VehicleCommercial)

import AddressChange from '@/components/initio/formulate/AddressChange'
Vue.component('AddressChange', AddressChange)

import ChosenVehicle from '@/components/initio/formulate/ChosenVehicle.vue'
Vue.component('ChosenVehicle', ChosenVehicle)

import InputMask from '@/components/initio/formulate/InputMask.vue'
Vue.component('InputMask', InputMask)

import InfoBox from '@/components/initio/formulate/InfoBox.vue'
Vue.component('InfoBox', InfoBox)

import LocatioAddressAutocomplete from '@/components/initio/formulate/LocatioAddressAutocomplete.vue'
Vue.component('LocatioAddressAutocomplete', LocatioAddressAutocomplete)

import CustomLabel from '@/components/initio/formulate/CustomLabel'
Vue.component('CustomLabel', CustomLabel)

import MainDriver from '@/components/initio/formulate/MainDriver'
Vue.component('MainDriver', MainDriver)

import MainDriverDisplay from '@/components/initio/formulate/MainDriverDisplay'
Vue.component('MainDriverDisplay', MainDriverDisplay)

import VehicleExcessUnder25 from '@/components/initio/formulate/VehicleExcessUnder25'
Vue.component('VehicleExcessUnder25', VehicleExcessUnder25)

import VehicleNoExcessGlass from '@/components/initio/formulate/VehicleNoExcessGlass'
Vue.component('VehicleNoExcessGlass', VehicleNoExcessGlass)

import VehicleDriverUnder25 from '@/components/initio/formulate/VehicleDriverUnder25'
Vue.component('VehicleDriverUnder25', VehicleDriverUnder25)

import CustomHelp from '@/components/initio/formulate/CustomHelp'
Vue.component('CustomHelp', CustomHelp)

import ClaimDropoff from '@/components/initio/formulate/ClaimDropoff'
Vue.component('ClaimDropoff', ClaimDropoff)

import ClaimHistoryDate from '@/components/initio/formulate/ClaimHistoryDate'
Vue.component('ClaimHistoryDate', ClaimHistoryDate)

import InlineText from '@/components/initio/InlineText'
Vue.component('InlineText', InlineText)

import Modal from '@/components/initio/Modal'
Vue.component('Modal', Modal)

import Declaration from '@/components/initio/formulate/Declaration'
Vue.component('Declaration', Declaration)

import VehicleEffectiveDatePicker from '@/components/initio/formulate/VehicleEffectiveDatePicker'
Vue.component('VehicleEffectiveDatePicker', VehicleEffectiveDatePicker)

import InternationalPhoneNumber from '@/components/initio/formulate/InternationalPhoneNumber'
Vue.component('InternationalPhoneNumber', InternationalPhoneNumber)

import PasswordValidation from "@/components/initio/formulate/PasswordValidation";
Vue.component('PasswordValidation', PasswordValidation)

import GoogleAddressAutoComplete from '@/components/initio/formulate/GoogleAddressAutoComplete'
Vue.component('GoogleAddressAutoComplete', GoogleAddressAutoComplete)


// Register v-tooltip (or whatever extras you might want to use)
Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})


// TODO - decide if we want to switch to this logic, which won't explode when you pass in a non number
// let number = parseFloat(value).toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
import { toCurrency } from '@/helpers/currencyHelper.js'

Vue.filter('toCurrency', function (value) {
  let number = toCurrency(value, 2);
  return `$${number}`;
  // return `$${value.toLocaleString(undefined, {
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // })}`;
});

Vue.filter('toCurrencyNoSymbol', function (value) {
  let number = toCurrency(value, 2);
  return `${number}`;
});

Vue.filter('toCurrencyShort', function (value) {
  let number = toCurrency(value, 0);
  return `$${number}`;
});


Vue.filter('toCurrencyNoSymbolShort', function (value) {
  let number = toCurrency(value, 0);
  return `${number}`;
});

Vue.filter('capitalize', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

// Import mobile-phone number validator
import parsePhoneNumber from 'libphonenumber-js/mobile'


Vue.use(VueFormulate, {
  library: {
    vehiclecoverslider: {
      classification: 'text',
      component: 'VehicleCoverSlider',
      slotProps: {
        
      }
    },
    vehiclecommercial: {
      classification: 'text',
      component: 'VehicleCommercial',
      slotProps: {
        
      }
    },
    chosenvehicle: {
      classification: 'text',
      component: 'ChosenVehicle'
    },
    inputmask: {
      classification: 'text',
      component: 'InputMask',
      slotProps: {
        component: ['mask']
      }
    },
    infobox: {
      classification: 'text',
      component: 'InfoBox',
      slotProps: {
        component: ['label']
      }
    },
    locatioaddressautocomplete: {
      classification: 'text',
      component: 'LocatioAddressAutocomplete'
    },
    vehicleexcessunder25: {
      classification: 'text',
      component: 'VehicleExcessUnder25',
      slotProps: {
        component: ['noteToExcessOptions']
      }
    },
    vehiclenoexcessglass: {
      classification: 'text',
      component: 'VehicleNoExcessGlass',
      slotProps: {
        component: ['content']
      }
    },
    maindriver: {
      classification: 'select',
      component: 'MainDriver',
      slotProps: {

      }
    },
    maindriverdisplay: {
      classification: 'text',
      component: 'MainDriverDisplay',
      slotProps: {

      }
    },
    vehicledriverunder25: {
      classification: 'radio',
      component: 'VehicleDriverUnder25'
    },
    addresschange: {
      classification: 'radio',
      component: 'AddressChange'
    },
    claimdropoff: {
      classification: 'text',
      component: 'ClaimDropoff'
    },
    claimhistorydate: {
      classification: 'text',
      component: 'ClaimHistoryDate'
    },
    inlinetext: {
      classification: 'text',
      component: 'InlineText'
    },
    declaration: {
      classification: 'text',
      component: 'Declaration'
    },
    vehicleeffectivedatepicker: {
      classification: 'text',
      component: 'VehicleEffectiveDatePicker'
    },
    internationalphonenumber: {
      classification: 'text',
      component: 'InternationalPhoneNumber'
    },
    passwordvalidation: {
      classification: 'text',
      component: 'PasswordValidation'
    },
    googleaddressautocomplete: {
      classification: 'text',
      component: 'GoogleAddressAutoComplete'
    },
  },
   // Define our custom slot component(s)
   slotComponents: {
    label: 'CustomLabel',
    help: 'CustomHelp',
  },
  // Define any props we want to pass to our slot component
  slotProps: {
    label: ['tooltip'],
    help: ['helpModal']
  },
  rules: {
    // This rule is designed specifically for the LocatioAddressAutoComplete custom formulate component
    locatio: ({name, value}) => {
      return (
        value[`${name}_cant_find`]
        || (
          value[`${name}_locatio_id`]
            && parseInt(value[`${name}_locatio_id`]) > 0
        )
      )
    },
    locatioAltAddress: ({name, value}) => {
      return (
        !value[`${name}_cant_find`]
        || (
          value[`${name}_street_locatio_id`]
            && parseInt(value[`${name}_street_locatio_id`]) > 0
            && parseInt(value[`${name}_street_number`]) > 0
        )
      )
    },
    // This rule is designed specifically for the internationalphonenumber component, specifically the valid_phone validation
    phone: ({name, value}) => {
      // console.log('phone validation rule via formulate', 'name',name, 'value', value,  value[`${name}`]);
      value = typeof value === 'undefined' ? '' : value;
      if( !value){
        return false;
      }
      const phone_number = parsePhoneNumber(value);
       // console.log(value, typeof value, phone_number, phone_number.isValid());
      // Based on teh type of input of phone number validation, this will validate against both / mobile only
      return  phone_number.isValid();
     },
    password: ({name, value}) => {
        // Some validation logic duplication between here and PasswordValidation.vue
        if (!value) return false;

        const rules = {
            lowercase: /[a-z]/,
            uppercase: /[A-Z]/,
            number: /[0-9]/,
            special: /[!@#$%^&*(),.?":{}|<>]/,
            length: /.{8,}/
        };

        return Object.values(rules).every(rule => rule.test(value));
    }
  }
})

import App from './App.vue'

// import './stylesheets/main.scss';
require('@/scss/main.scss');

Vue.config.productionTip = false

Vue.directive('uppercase', { 
    bind(el, _, vnode) {
      el =  el.querySelector('input');
      el.addEventListener('keyup', (e) => {
        e.target.value = e.target.value.toUpperCase()
        vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
      })
    }
})

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import router from './routes/routes';
import store from './store/store';




new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')

// TODO - add page loader until these are complete

// Get the Stripe key on load
store.dispatch('getStripeKey')

// // Load in client data
// store.dispatch('getClientData')

// Vue.config.devtools = true
